import React from "react";
import { experience } from "../../v3/data";

const Experience = () => (
  <section id="experience" className="section soft rv">
    <div className="pagewrap">
      <div className="shead">
        <div>
          <div className="snum">[ 04 / EXPERIENCE ]</div>
          <h2 className="h2">Where I've worked.</h2>
        </div>
        <a href="#contact" className="mono fs13 hide-mobile">
          next: your project? →
        </a>
      </div>
      <div style={{ borderBottom: "1px solid var(--line)" }}>
        {experience.map((e) => (
          <div key={e.dates} className="exp-row stag">
            <div className="mono" style={{ fontSize: 12.5, fontWeight: 500, color: "var(--accent)", paddingTop: 3 }}>
              {e.dates}
            </div>
            <div>
              <h3 style={{ fontSize: 18, fontWeight: 600, margin: "0 0 2px" }}>
                {e.role} <span style={{ color: "var(--muted)", fontWeight: 500 }}>· {e.company}</span>
              </h3>
              <p style={{ fontSize: 14.5, lineHeight: 1.65, color: "var(--muted)", margin: "8px 0 0", maxWidth: 560 }}>{e.desc}</p>
            </div>
            <span className="tag">{e.location}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Experience;
